class BoxContents extends HTMLElement {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
  }

  connectedCallback() {
    this.scope = this.closest('product-info');
    this.scope.addEventListener('change', this.handleChange);
    this.sync();
  }

  disconnectedCallback() {
    this.scope?.removeEventListener('change', this.handleChange);
  }

  handleChange(event) {
    if (event.target.matches('[data-add-on-option]')) {
      this.sync(event.target.value);
    }
  }

  sync(state) {
    const currentState = state ?? this.scope?.querySelector('[data-add-on-option]:checked')?.value ?? 'none';
    this.querySelectorAll('[data-eval-compute]').forEach((el) => {
      el.hidden = el.dataset.evalCompute !== currentState;
    });
  }
}

if (!customElements.get('box-contents')) {
  customElements.define('box-contents', BoxContents);
}
